import axios from 'axios';
import cfac22 from '../cfac22';
import authToken from './authToken';

export function getCardsByOrgsNode(uid, orgId) {
  return new Promise((resolve, reject) => {
    authToken(uid)
      .then((token) => {
        axios
          .get(cfac22('API_HOST_V2') + `/cards/getCardsByOrgs/?orgId=${orgId}&uId=${uid}`, {
            headers: { authorization: 'Bearer ' + token, 'Full-Url': window.location.href },
          })
          .then((result) => {
            resolve(result.data.result);
          })
          .catch((error) => {
            return reject(error.data.error);
          });
      })
      .catch((error) => {
        // console.log("ERROR_TOKEN ===>", error);
        reject(error.response.data);
      });
  });
}
